import React from 'react';
import { IIconProps } from './IIconProps';

export const TickIcon = ({
	iconClass = '',
	title = '',
	onClick,
	...props
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={iconClass}
			fill="none"
			// To pass data-attributes to the icon
			{...props}
		>
			{title && <title>{title}</title>}
			<path d="M20 6L9 17L4 12" />
		</svg>
	);
};
